module.exports = __webpack_public_path__ + "media/newstyle/images/lp-banner-a-desktop-2ecc34653b078ef807666a5554a5b38c.png";